<template>
	<router-view class="shop-wrapper" />
</template>

<script>


export default {
	name: 'Shop',
};
</script>

<style lang="scss" scoped>
	.shop-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		max-width: $max-content-width;

		@include desktop {
			justify-content: flex-start;
			margin-top: 20px;
		}

		@include desktop-sm { padding-top: $header-height-desktop; }
	}
</style>
